/**
 * Shop Commands
 * Commands for managing e-commerce products and shop functionality
 */

import { SelfContainedCommand } from '../../types/commands';
import { productCreateCommand } from './product_create';

export const shopCommands: SelfContainedCommand[] = [
  productCreateCommand
];
